<script src="devices-controller.es6"></script><div id="safety-app" ng-controller="DevicesCtrl"></div>